/*
 * Copyright (c) 2017.  Spin in het Web BV Apeldoorn
 * Geen toestemming zonder gebruik zonder schriftelijke overeenkomst
 * Ook bij schriftelijke overeenkomst is het gebruik van deze code
 * beperkt tot de in de overeenkomst opgenomen voorwaarden.
 */

/**
 * SPIN IN HET WEB APELDOORN
 * User: Jelmer Jellema
 * Date: 17-8-2016
 * Time: 14:22
 *
 */

angular.module('sihw.sihwlog', [])
    .provider('sihwlog', function provideSihwlog() {
        let enabled = true; //standaard
        let minLevel = 1; //logs onder het minLevel uit de config worden niet getoond

        //opvolging van levels. Je zet de logger aan voor een bepaald niveau. Daaronder wordt dan niet afgebeeld
        let levels = {
            'debug': 1,
            'log': 2,
            'info': 3,
            'warn': 4,
            'error': 5
            // 'geen': 6 //zet op loglevel 'geen' om niets te doen (zelfde als een ander loglevel en dan .enabled(false))
        };

        return {
            //CONFIGURATIE PROVIDER sihwlogProvider

            /**
             * Schakel alle logging centraal in of uit
             * @param bEnabled
             */
            enabled: function (bEnabled) {
                enabled = bEnabled;
                return this;
            },

            /**
             * Zet het minimale level
             * @param strMinlevel
             */
            minLevel: function(strMinlevel) {
                minLevel = levels[strMinlevel];
                return this;
            },

            $get: [function () {
                //sihwlog SERVICE
                return {
                    /**
                     * Wijzig in runtime de enabled state voor *nieuwe* logobjecten
                     * @param {boolean} [bEnabled] nieuwe toestand, optioneel: als niet gegeven dan wijzigt de toestand niet
                     * @returns {boolean} de enabled-toestand
                     */
                    enabled: function (bEnabled) {
                        if (typeof(bEnabled) != "undefined") {
                            enabled = bEnabled;
                        }
                        return enabled;
                    },

                    /**
                     * De noop-functie, als prop zodat unit-testing kan vergelijken
                     */
                    noop:  function () {
                    },

                                /**
                     * Return een log-object dat logt op het opgegeven level of hoger.
                     * @param level
                     */
                    logLevel: function (level) {
                        let loggerLevel = level || 'geen';
                        let loggerEnabled = enabled; //locale kopie van huidige toestand, loopt niet meer synchroon
                        let $service = this;
                        let logger = {
                            /**
                             * Wijzig de enabled-toestand van het lokale logger-object - niet van de globale service
                             * @param bEnabled
                             * @return {*|boolean}
                             */
                            enabled: function (bEnabled) {
                                loggerEnabled = bEnabled;
                                this.reload(); //opnieuw opzetten
                                return loggerEnabled;
                            },
                            /**
                             * Wijzig het loglevel van het loakel logger-object, niet van de globale service, return de logger zelf
                             * @param level
                             * @return {*}
                             */
                            logLevel: function (level) {
                                loggerLevel = level;
                                this.reload();
                                return this;
                            },

                            /**
                             * 2020: we kunnen setters en getters maken
                             * @returns {*|string}
                             */
                            get level() {
                                return loggerLevel;
                            },
                            set level(level) {
                                this.logLevel(level)
                            },

                            /**
                             * Geeft aan of we zouden loggen op het opgegeven niveau
                             * @param {string} level
                             * @returns {boolean}
                             */
                            logtOpLevel(level) {
                                return this[level] !== $service.noop;
                            },

                            /**
                             * Zet de logger (opnieuw) op, gegeven loggerLevel en loggerEnabled
                             */
                            reload: function() {
                                if (!( loggerLevel in levels)) {
                                    console.warn('sihwlog.logLevel aangeroepen met onbekend level', loggerLevel);
                                }
                                let levelnr = levels[loggerLevel] || 1; //als niet gegeven, dan alle levels weergeven (vanaf de algemene minlevel)
                                let lokaalEnabled = loggerLevel === 'geen' ? false : loggerEnabled;
                                Object.keys(levels).forEach(function (l) {
                                    if (lokaalEnabled && levels[l] >= levelnr && levels[l] >= minLevel) {
                                        if (l === 'debug')
                                        {
                                            logger[l] = console.log.bind(console,'[DEBUG]');
                                        }
                                        else
                                        {
                                            logger[l] = console[l].bind(console);
                                        }
                                    }
                                    else {
                                        logger[l] = $service.noop; //de nopefunctie
                                    }
                                });
                            }
                        };
                        logger.reload();

                        return logger;
                    }
                };
            }]
        };
    });


